import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Truck, Heart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { toast } = useToast();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast({
      title: 'Produit ajouté au panier',
      description: product.name,
    });
  };

  return (
    <Link
      to={`/produit/${product.id}`}
      className="group bg-white rounded-xl border border-neutral-200 hover:border-[#00847A] hover:shadow-lg flex flex-col overflow-hidden"
    >
      <div className="relative aspect-square bg-neutral-50 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105"
          style={{ transition: 'transform 300ms ease' }}
          loading="lazy"
        />
        {product.discount > 0 && (
          <div className="absolute top-2 left-2 bg-[#FF4D4D] text-white text-xs font-bold px-2 py-1 rounded">
            -{product.discount}%
          </div>
        )}
        <button
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
          className="absolute top-2 right-2 w-9 h-9 bg-white hover:bg-neutral-100 border border-neutral-200 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100"
        >
          <Heart size={16} className="text-[#262626]" />
        </button>
      </div>

      <div className="p-3 flex flex-col flex-1">
        <div className="text-xs text-[#595959] mb-1">{product.brand}</div>
        <h3 className="text-sm text-[#262626] line-clamp-2 min-h-[40px] group-hover:text-[#00847A]">
          {product.name}
        </h3>

        <div className="flex items-center gap-1 mt-2">
          <div className="flex items-center">
            {[1,2,3,4,5].map(i => (
              <Star key={i} size={13} className={i <= Math.round(product.rating) ? 'fill-[#FFB800] text-[#FFB800]' : 'text-neutral-300'} />
            ))}
          </div>
          <span className="text-xs text-[#595959]">({product.reviews.toLocaleString('fr-FR')})</span>
        </div>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-xl font-bold text-[#262626]">{product.price.toFixed(2).replace('.', ',')} €</span>
          {product.oldPrice > product.price && (
            <span className="text-xs text-[#595959] line-through">{product.oldPrice.toFixed(2).replace('.', ',')} €</span>
          )}
        </div>

        <div className="flex items-center gap-1 mt-1 text-xs text-[#00847A]">
          <Truck size={13} /> {product.shipping} • {product.delivery}
        </div>

        <Button
          onClick={handleAdd}
          className="mt-3 w-full bg-[#00847A] hover:bg-[#006B63] text-white rounded-full h-9 text-sm font-semibold"
        >
          Ajouter au panier
        </Button>
      </div>
    </Link>
  );
};

export default ProductCard;
